import React, {useState} from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import * as dayjs from 'dayjs'
import * as utc from 'dayjs/plugin/utc'
import * as timezone from 'dayjs/plugin/timezone'
import * as relativeTime from 'dayjs/plugin/relativeTime'
import {ActionButton, FormGroup, useAlert} from "../components/FormComps"
import {useIntlEx} from "../components/IntlUtils.js"
import {useSolv} from "../components/SolvProvider";
import {ModalDialog} from "../components/DialogUtils";
import {clearAllErrors, InfoBlock, InfoText, validateField} from "../components/ValidationUtils";
import getLogger from "../components/Logging.js"
import '../App.css'

const log = getLogger("SignupRequestDeclineDialog")

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

export default function SignupRequestDeclineDialog(props)  {

  const {env, api, setBusy, setFatal} = useSolv()
  const {intl} = useIntlEx()

  const [alert, setAlert] = useAlert()

  const [signupRequest, setSignupRequest] = useState(null)
  const [message, setMessage] = useState(null)

  async function handleDeclineClick() {
    log.debug("handleDeclineClick: invoked" )

    if (signupRequest && validate()) {

      setBusy(intl.msg("working"))

      try {

        let payload = {
          message: message,
        }

        log.debug("decline: payload=", payload)

        await api.declineSignupRequest(signupRequest.signupRequestId, payload)

        window.location = `/sys/signupRequests`

      }
      catch (error) {
        handleError(error)
      }
      finally {
        setBusy(null)
      }
    } else {
      setAlert({type: "error", text: intl.msg("error_validation")})
    }

  }

  function validate() {

    let opt = {focusEl: null, valid: true}

    clearAllErrors("frmMain")

    validateField("inp_message", message && message.trim().length > 0, "required", opt)

    if (opt.focusEl) {
      document.getElementById(opt.focusEl).focus()
    }

    return opt.valid

  }

  function handleError(error) {
    if (error && error.code) {
      // log.debug("handleError", error.code)
      const code = error.code
      const details = error.details
      switch (code) {
        case "INVALID_SIGNUP_REQUEST":
          setAlert({type: "error", text: intl.msg("signup_request_error_invalid_signup_request", details)})
          break
        case "UNKNOWN_INVITER":
        case "INVALID_INVITER":
          setAlert({type: "error", text: intl.msg("invite_error_invalid_inviter", details), field: "inp_emailAddresses", constraint: "valid"})
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed", details)})
          break
      }
    }
    else {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  function handleMessageChange(e) {
    setMessage(e.target.value)
  }

  function handleOpenDialog() {
    if (props?.signupRequestId) {
      setBusy(intl.msg("loading"))
      api.getSignupRequest(props.signupRequestId)
        .then(({data}) => {
          log.debug("handleOpenDialog: getSignupRequest: data=", data)
          setSignupRequest(data)
        })
        .catch((error) => {
          log.error(error)
          setFatal(error)
        })
        .finally(() => {
          setBusy(null)
        })
    }
  }

  function handleCloseDialog() {
    window.location = `/sys/signupRequests/${props.signupRequestId}`
  }


  return (

    <ModalDialog
      dialogId="dlg_signup_request_decline"
      size="lg" keyboard={"true"} backdrop={props.backdrop || "static"}
      alert={alert}
      onOpen={handleOpenDialog}
      onClose={handleCloseDialog}>

      <ModalDialog.Header title={intl.msg("signup_request_decline_title")} description={intl.msg("signup_request_decline_description")} alert={alert}/>

      <ModalDialog.Body>

        <FormGroup>
          <FormGroup.Label htmlFor="inp_message" text={intl.msg("signup_request_decline_message")} description={intl.msg("signup_request_decline_message_description")}/>
          <FormGroup.Controls>
            <textarea id="inp_message" className="form-control" value={message} placeholder={null} onChange={handleMessageChange}/>
            <InfoBlock>
              <InfoText validate="required">{intl.msg("helptext_required")}</InfoText>
            </InfoBlock>
          </FormGroup.Controls>
        </FormGroup>

      </ModalDialog.Body>

      <ModalDialog.Footer>
        <ModalDialog.Footer.Controls>
          <ActionButton name="cancel" onClick={handleCloseDialog}/>
          <ActionButton name="decline" confirm={intl.msg("confirm_decline")} flavor="primary" disabled={!message || message.trim().length == 0} onClick={handleDeclineClick}/>
        </ModalDialog.Footer.Controls>
      </ModalDialog.Footer>

    </ModalDialog>
  )
}